<template>
  <v-badge :dark="dark" class="d-block" :color="$colors.green" overlap>
    <template v-slot:badge>
      <span style="color: black">☕16</span>
    </template>
    <v-btn block :color="$colors.green" @click="openSupportPage">
      <v-icon class="pr-1">
        {{ icons["casho"] }}
      </v-icon>
      {{ randomEncourager }}
    </v-btn>
  </v-badge>
</template>

<script>
import { mdiCurrencyUsd } from "@mdi/js";
export default {
  data: () => ({
    icons: {
      casho: mdiCurrencyUsd,
    },
  }),
  computed: {
    dark() {
      return this.$store.state.USER.settings.dark;
    },
    randomEncourager() {
      let words = ["Bolster", "Donate", "Bestow", "Pledge", "Pitch in", "Contribute", "Support", "Endorse", "Fund", "Endow", "Chip in"];
      return words[Math.floor(Math.random() * words.length)];
    },
  },
  watch: {
    dark: {
      handler: function () {
        let border = document.getElementsByClassName("v-badge__badge");
        border = border[0];
        border.style.border = this.dark
          ? "2px solid #282828"
          : "2px solid #ebe9e9";
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    openSupportPage() {
      window.open("https://coff.ee/blockables", "_blank").focus();
    },
  },
  mounted() {
    let border = document.getElementsByClassName("v-badge__badge");
    border = border[0];
    border.style.border = this.dark ? "2px solid #282828" : "2px solid #ebe9e9";
  },
};
</script>

<style>
.v-badge__badge {
  border-radius: 12px;
  height: 24px;
}
</style>
